import _ from 'lodash';
import { fromJsonArray } from 'src/core/utils';
import { MyOffer } from 'src/entities/offer/MyOffer';
import { Offer } from 'src/entities/offer/Offer';
import { entityCollectionDefaultState, EntityCollectionState } from '../entities/types/EntityCollectionState';

/**
 * Fetch my offers
 */
export const getMyOffers = (state: any): EntityCollectionState<MyOffer> => {
    const data = state.myOffers;

    if (_.isEmpty(data)) return entityCollectionDefaultState<MyOffer>();

    return {
        isFetching: data.isFetching,
        error: data.error,
        items: fromJsonArray(MyOffer, data.items),
    };
};

/**
 * Fetch offers
 */
export const getOffers = (state: any): EntityCollectionState<Offer> => {
    const data = state.offers;

    if (_.isEmpty(data)) return entityCollectionDefaultState<Offer>();

    return {
        isFetching: data.isFetching,
        error: data.error,
        items: fromJsonArray(Offer, data.items),
    };
};
